function lowerCaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
}

//mapping objects from WS as they come with First leter uppercase in comparison to HTTP response
export let objectKeysFirstLetterToLowerCase = function (input) {
    if (typeof input !== 'object') return input
    if (Array.isArray(input)) return input.map(objectKeysFirstLetterToLowerCase)
    return Object.keys(input).reduce(function (newObj, key) {
        let val = input[key]
        let newVal = typeof val === 'object' && val !== null ? objectKeysFirstLetterToLowerCase(val) : val
        newObj[lowerCaseFirstLetter(key)] = newVal
        return newObj
    }, {})
}
